/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {InputTextComponent} from '../input-text/input-text.component';
import {UntypedFormBuilder} from '@angular/forms';

@Component({
    selector: 'app-input-units',
    templateUrl: './input-units.component.html',
    styleUrls: [
        '../input/input.component.css',
        './input-units.component.css'
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputUnitsComponent extends InputTextComponent implements OnInit, OnDestroy {
    @Input() units = '';
    @Input() width = 'auto';
    @Input() decimalDirective = false;


    constructor(protected formBuilder: UntypedFormBuilder) {
        super(formBuilder);
    }

    get unitsInputCypressTag(): string {
        return `${this.baseCypressTag}-units`;
    }
}
